import { captureFbclid, rawLandingSearch } from '~/utils/meta-click-id';

// Captures Meta's `fbclid` ad-click parameter from the landing URL so
// `buildMetaConversionContext()` can build an `fbc` at payment time when Meta's
// `_fbc` cookie is absent. See `app/utils/meta-click-id.ts`.
//
// DELIBERATELY separate from `meta-pixel.client.ts`: the pixel plugin exits
// early when `metaPixelId` is blank, but the backend's server-side Conversions
// API still benefits from `fbc`, so capture must not depend on the pixel being
// configured. Opt-out is handled inside `captureFbclid()` (captures nothing and
// clears any stored entry).
//
// Runs once at app start, while the landing URL still carries `fbclid`. Initial
// load is enough: an ad click always arrives as a full page load, never as an
// in-app route change.
//
// The query is read RAW from the original document request URL (the Navigation
// Timing entry) via `rawLandingSearch()` — never `route.query` or
// `URLSearchParams`, both of which percent-decode the value Meta requires
// unmodified, and NOT `window.location.search` directly: the router normalizes
// the query with `history.replaceState` during startup, so whether this plugin
// sees the raw or the decoded value is a race (#1977). `location.search` is
// only the fallback when the navigation entry is unavailable.

export default defineNuxtPlugin(() => {
  captureFbclid(rawLandingSearch(), Date.now());
});
